import { render, staticRenderFns } from "./groupForOthers.vue?vue&type=template&id=45548f1e"
import script from "./groupForOthers.vue?vue&type=script&lang=js"
export * from "./groupForOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports